/**
 * The native footprint metric is unavailable on web and in non-native test runtimes.
 */
export function useMemoryFootprint(_enabled?: boolean): null {
  return null;
}
